export default {
    data() {
        return {
            columns: [
                {
                    title: $t('public.table_scope'),
                    index: 'name'
                },
                {
                    title: $t('public.table_customer_code'),
                    index: 'code'
                },
                {
                    title: $t('public.status'),
                    index: 'status',
                    iconOnly: true,
                    icon: [
                        {
                            type: 'customerStatus',
                            index: 'status'
                        }
                    ]
                },
                {
                    title: $t('public.table_contact'),
                    index: 'contact'
                },
                {
                    title: $t('public.table_phone'),
                    index: 'phone'
                },
                {
                    title: $t('public.table_email'),
                    index: 'email'
                },
                {
                    title: $t('public.table_operation'),
                    operation: [
                        {
                            switch: {
                                0: {
                                    type: 'inactive',
                                    tip: true,
                                    click: this.statusFn
                                },
                                1: {
                                    type: 'active',
                                    tip: {
                                        content: $t('integration.when_logging_off_a_customer_c__the_associated_roles/users/monitoring_tools/monitoring_points_will_be_deactivated_dot__are_you_sure_you_want_to_log_off_q')
                                    },
                                    click: this.statusFn
                                }
                            },
                            index: 'status'
                        },
                        {
                            type: 'detail',
                            click: this.detailFn
                        }
                    ]
                }
            ]
        };
    },
    methods: {
        orgtypeFn(type) {
            let str = '';
            for (let item of this.typeArray) {
                if (type === item.value) {
                    str = this.$t(item.label);
                    break;
                }
            }
            return str;
        }
    }
};
